import {
  ExperienceCompatibilityTypeEnum,
  ExperienceTypeEnum,
} from '@koob/enums';
import { getExperience } from 'api/node/experiences';
import { Form, Formik } from 'formik';
import { useMemo, useState } from 'react';
import { useAsync } from 'react-async';
import { useParams } from 'react-router-dom';
import { post } from '../../../api/node';
import ExperienceHeader from '../Form/Partials/ExperienceHeader';
import ExperienceLayout from '../Form/Partials/ExperienceLayout';
import CompatibilityForm from './CompatibilityForm';

export const getExperiencesList = async ({
  state = '',
  type = '',
  search = '',
  except,
  themes,
  segments,
  cities,
  countries,
  startingPoint,
  endingPoint,
  notStartingAt,
  notEndingAt,
  types = [ExperienceTypeEnum.PROGRAM],
}) => {
  return await post('/experiences/liste', {
    search,
    type,
    startingPoint,
    endingPoint,
    notStartingAt,
    notEndingAt,
    state: state && state !== 'all' ? state : undefined,
    except,
    cities,
    countries,
    themes,
    segments,
    includePartnerExperiences: true,
    types,
  });
};

export function ExperienceCompatibility({ reloadExperience }) {
  const { experienceId } = useParams();

  const [currentStep, setCurrentStep] = useState(0);
  const [isSaved, setIsSaved] = useState(false);
  const [showRecap, setShowRecap] = useState(false);

  const { data: experienceData } = useAsync({
    promiseFn: getExperience,
    experienceId,
  });

  const experience = useMemo(() => {
    if (!experienceData?.data)
      return {
        id: experienceId,
        name: '',
        startPosition: '',
        endPosition: '',
        extras: experienceData?.data?.extras || [],
      };

    return {
      ...experienceData.data,
      startPosition:
        experienceData.data.startPosition?.name ||
        experienceData.data.inCity?.title ||
        '',
      endPosition:
        experienceData.data.endPosition?.name ||
        experienceData.data.inCity?.title ||
        '',
    };
  }, [experienceData, experienceId]);

  const initialFormValues = useMemo(() => {
    const bestMatches = experienceData?.data?.bestMatches || [];
    const incompatibilities = experienceData?.data?.incompatibilities || [];

    return {
      themes: [],
      segments: [],
      step1_best: bestMatches.filter(
        (e) => e.direction === ExperienceCompatibilityTypeEnum.FOR,
      ),
      step2_black: incompatibilities.filter(
        (e) => e.direction === ExperienceCompatibilityTypeEnum.FOR,
      ),
      step3_best: bestMatches.filter(
        (e) => e.direction === ExperienceCompatibilityTypeEnum.TO,
      ),
      step4_black: incompatibilities.filter(
        (e) => e.direction === ExperienceCompatibilityTypeEnum.TO,
      ),
    };
  }, [experienceData]);

  return (
    <>
      <ExperienceHeader experience={experienceData?.data} />
      <ExperienceLayout>
        <Formik
          enableReinitialize={true}
          initialValues={initialFormValues}
          onSubmit={(values) => {
            setShowRecap(true);
          }}
        >
          <Form>
            <CompatibilityForm
              experience={experience}
              isSaved={isSaved}
              setIsSaved={setIsSaved}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
              showRecap={showRecap}
              setShowRecap={setShowRecap}
              reloadExperience={reloadExperience}
            />
          </Form>
        </Formik>
      </ExperienceLayout>
    </>
  );
}
